import type { ReactNode } from 'react'

export type SpeechBubbleProps = {
  speaker: 'kunduz' | 'disdis'
  children: ReactNode
}

/** Doktor Kunduz speaks in sky, Dişdiş in tooth white. */
export function SpeechBubble({ speaker, children }: SpeechBubbleProps) {
  return (
    <p className={['bubble', speaker === 'kunduz' ? 'bubble--kunduz' : ''].join(' ')}>{children}</p>
  )
}
